import { render, staticRenderFns } from "./Ppc2.vue?vue&type=template&id=4414ab9a&scoped=true&"
import script from "./Ppc2.vue?vue&type=script&lang=js&"
export * from "./Ppc2.vue?vue&type=script&lang=js&"
import style0 from "./Ppc2.vue?vue&type=style&index=0&id=4414ab9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4414ab9a",
  null
  
)

export default component.exports